import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import _ from 'lodash';
import { isStaticRender } from 'helpers/ContentHelper';
import DropdownIcon from 'components/DropdownIcon';
import Dropdown from 'components/Dropdown';
import DropdownStyle from 'screens/Search/components/SearchDropdown/SearchDropdown.module.scss';
import Style from './SearchTabs.module.scss';

export default class SearchTabs extends Component {
  constructor(props) {
    super(props);
    let filter = null;
    if (isStaticRender()) {
      const { panels: nextPanels, selectedTab: nextSelectedTab, renderFilters } = props;
      const selectedPanel = _.get(nextPanels, `member.${nextSelectedTab}`, nextPanels?.member[0]);
      filter = renderFilters(selectedPanel);
    }

    this.state = {
      filter,
      categoryDropdownOpen: false,
    };
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const { panels: nextPanels, selectedTab: nextSelectedTab, renderFilters } = nextProps;
    const { isDropdownOpen } = this.props;
    if (nextPanels && this.props !== nextProps) {
      const selectedPanel = _.get(nextPanels, `member.${nextSelectedTab}`, nextPanels?.member[0]);
      const filter = renderFilters(selectedPanel);
      this.setState({ filter });
    }
    if (!isDropdownOpen && nextProps.isDropdownOpen) {
      this.setState({ categoryDropdownOpen: false });
    }
  }

  toggleCategoryDropdown = () => {
    const { toggleShowFilter, scrollToTop } = this.props;
    const { categoryDropdownOpen } = this.state;
    this.setState({ categoryDropdownOpen: !categoryDropdownOpen });
    toggleShowFilter(!categoryDropdownOpen);
    if (!categoryDropdownOpen) scrollToTop();
  };

  renderCategoryDropdown(panels) {
    if (!panels) return null;
    const { categoryDropdownOpen } = this.state;
    const { selectedTab, tabChanged, showMobileCancel, isDropdownOpen } = this.props;
    const isOpen = isDropdownOpen ? false : categoryDropdownOpen;

    const defaultText = _.get(panels, `member.${selectedTab}.headline`);

    const items = panels?.member.map((member, idx) => {
      const { headline, collectionType } = member;
      const onClick = () => {
        tabChanged(idx, headline, collectionType);
      };
      return {
        name: headline,
        onClickParams: idx,
        onClick,
        isSelected: idx === selectedTab,
      };
    });

    return (
      <div className={Style.categoryDropdown} data-test="search-tabs-dropdown">
        <Dropdown
          items={items}
          getIcon={onClick => <DropdownIcon onClick={onClick} opened={isOpen} />}
          defaultText={defaultText}
          onOpenDropdown={this.toggleCategoryDropdown}
          onCloseDropdown={this.toggleCategoryDropdown}
          displayResults={isOpen}
          showMobileCancel={showMobileCancel}
          theme={DropdownStyle}
          expanded={isOpen}
        />
      </div>
    );
  }

  renderTabs(panels) {
    if (!panels) return null;
    const { selectedTab, tabChanged } = this.props;

    const tabs = panels?.member.map((panel, idx) => {
      const { '@id': panelId, headline, collectionType } = panel;
      // TODO: Restore this line once the API delivers safe images again
      const url = null; // getHeaderLogo(panel, 50);
      const item = url ? <img src={url} alt={headline} /> : headline;

      const classname = classNames([Style.tabItem, idx === selectedTab ? Style.active : null]);
      const onClick = () => {
        tabChanged(idx, headline, collectionType);
      };
      return (
        <TabItem
          key={panelId}
          panelId={panelId}
          data-test="searchtabs-tabitem"
          classname={classname}
          content={item}
          onClick={onClick}
        />
      );
    });

    return (
      <div className={Style.tabs} data-test="search-tabs-category">
        {tabs}
      </div>
    );
  }

  render() {
    const { panels } = this.props;
    const { filter } = this.state;
    return (
      <div className={Style.filters}>
        {this.renderCategoryDropdown(panels)}
        {this.renderTabs(panels)}
        {filter && <div className={Style.filterDropdown}>{filter}</div>}
      </div>
    );
  }
}

SearchTabs.defaultProps = {
  isDropdownOpen: false,
  panels: {},
  selectedTab: null,
  toggleShowFilter: () => {},
};

SearchTabs.propTypes = {
  isDropdownOpen: PropTypes.bool,
  panels: PropTypes.shape({}),
  renderFilters: PropTypes.func.isRequired, // eslint-disable-line react/no-unused-prop-types
  scrollToTop: PropTypes.func.isRequired,
  selectedTab: PropTypes.number,
  showMobileCancel: PropTypes.bool.isRequired,
  tabChanged: PropTypes.func.isRequired,
  toggleShowFilter: PropTypes.func,
};

const TabItem = ({ panelId, classname, content, onClick }) => (
  <button
    key={`${panelId}`}
    className={classname}
    data-test="search-tabs-category-item"
    onClick={onClick}
  >
    {content}
  </button>
);

TabItem.defaultProps = {
  classname: null,
  content: null,
  onClick: () => {},
  panelId: null,
};

TabItem.propTypes = {
  classname: PropTypes.string,
  content: PropTypes.node,
  onClick: PropTypes.func,
  panelId: PropTypes.string,
};
